import React from "react";
import { Link } from "react-router-dom";

export default function Copyright() {
  return (
    <footer className="lt-footer">
      <div className="lt-main">
        边角聊 LEFTOVER TALK · © {new Date().getFullYear()} ·{" "}
        <Link to="/privacy">隐私政策</Link> · <Link to="/help">帮助</Link>
      </div>
    </footer>
  );
}
